import React from 'react';

import { Control, Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useFilterCount } from '../hooks';
import { CustomFilterPopover } from './CustomFilterPopover';

export function InputPopover({
  fieldName,
  fieldLabel,
  onCountChange = undefined,
  testId = `${fieldName}_Filter`,
  ...props
}) {
  const { t } = useTranslation();
  const { register, setValue } = useFormContext();

  const fieldValue = useWatch({ name: fieldName });
  const filterCount = fieldValue ? 1 : 0;
  useFilterCount(fieldName, filterCount, onCountChange);

  const handleReset = () => {
    setValue(fieldName, '');
  };

  return (
    <CustomFilterPopover
      {...props}
      hasFilterValue={Boolean(filterCount)}
      testId={testId}
      triggerValue={fieldLabel}
    >
      <Control.Input
        id={fieldName}
        label={fieldLabel}
        {...register(fieldName)}
      />
      <Divider small />
      <Control.Button
        disabled={filterCount === 0}
        kind="negative"
        onClick={handleReset}
        size="small"
        variant="filled"
      >
        {t('button.clear')}
      </Control.Button>
    </CustomFilterPopover>
  );
}
